import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade"
import ItemExecucaoPlanoQualidade from "model/qualidade/ItemExecucaoPlanoQualidade"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { InputTextarea } from "primereact/inputtextarea"
import ExecucaoPlanoQualidadeService from "service/qualidade/ExecucaoPlanoQualidadeService"
import { converterDataHora } from "utils/convert"

type Props = {
    value: ExecucaoPlanoQualidade
    editable: boolean;
    onChange: (value: ExecucaoPlanoQualidade) => void
}

const execucaoPlanoQualidadeService = new ExecucaoPlanoQualidadeService();

export default function ExecucaoPlano(props: Props) {

    const bodyStatus = (rowData: any) => {
        if (props.editable) {
            return <Dropdown value={rowData.status} options={execucaoPlanoQualidadeService.getItemStatus()} style={{ width: "100%" }} onChange={(e) => {
                rowData.status = e.value;
                props.onChange(props.value);
            }} />
        }

        return execucaoPlanoQualidadeService.getItemStatusLabel(rowData.status)
    }

    const bodyResultado = (rowData: ItemExecucaoPlanoQualidade) => {
        if (rowData.tipoResultado === "NUMERICO") {
            if (props.editable) {
                return <InputNumber value={rowData.resultadoNumerico}
                    minFractionDigits={1}
                    locale="pt-BR"
                    style={{ width: "100%" }}
                    onChange={(e) => {
                        rowData.resultadoNumerico = e.value as number;
                        props.onChange(props.value);
                    }
                    } />
            }

            return rowData.resultadoNumerico;
        }
        if (rowData.tipoResultado === "TEXTO") {
            if (props.editable) {
                return <InputText value={rowData.resultadoTexto} style={{ width: "100%" }} onChange={(e) => {
                    rowData.resultadoTexto = e.target.value;
                    props.onChange(props.value);
                }} />
            }

            return rowData.resultadoTexto;
        }
        if (rowData.tipoResultado === "SIM_NAO") {
            let options = [{ label: "Sim", value: "S" }, { label: "Não", value: "N" }];
            if (props.editable) {
                return <Dropdown value={rowData.resultadoSimNao}
                    options={options}
                    optionLabel="label"
                    optionValue="value"
                    style={{ width: "100%" }}
                    onChange={(e) => {
                        rowData.resultadoSimNao = e.target.value;
                        props.onChange(props.value);
                    }} />
            }

            return options.find((opcao) => opcao.value === rowData.resultadoSimNao)?.label || "";
        }

        return "";
    }

    const numberTemplate = (rowData: any, options: any) => {
        if(rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Geração</label>
                <div className="col-sm-12">
                    <InputText value={converterDataHora(props.value.dataGeracao)} disabled style={{ width: '20%' }} />
                </div>
            </div>
            <div style={{ display: "flex", marginBottom: 12 }}>
                <div style={{ display: "flex", flexDirection: "column", width: "20%", marginRight: 10 }}>
                    <label style={{ fontWeight: "bold" }}>Última altereação</label>
                    <InputText value={converterDataHora(props.value.dataAlteracao)} disabled style={{ width: '100%' }} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", width: "20%" }}>
                    <label style={{ fontWeight: "bold" }}>Usuário</label>
                    <InputText value={props.value.usuarioAlteracao?.nome || ""} disabled style={{ width: '100%' }} />
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Status</label>
                <div className="col-sm-12">
                    <Dropdown
                        options={execucaoPlanoQualidadeService.getStatus()}
                        optionLabel="label"
                        optionValue="value"
                        optionDisabled={(option) => option.value === "CANCELADA"}
                        value={props.value.status}
                        disabled={!props.editable}
                        style={{ width: '20%' }}
                        onChange={(e) => {
                            if (props.editable) {
                                props.value.status = e.value;
                                props.onChange(props.value);
                            }
                        }}
                    />
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Observação</label>
                <div className="col-sm-12">
                    <InputTextarea value={props.value.observacao} disabled={!props.editable} style={{ width: '100%' }} rows={3} maxLength={255} onChange={(e) => {
                        props.value.observacao = e.target.value;
                        props.onChange(props.value);
                    }} />
                </div>
            </div>


            <div className="row">
                <div className="col-sm-12">

                    <DataTable value={props.value.itens} emptyMessage="Nenhum registro encontrado">
                        <Column field="sequencial" header="Sequencial" />
                        <Column field="inspecaoQualidade.descricao" header="Nome" />
                        <Column field="valorAlvo" header="Valor Alvo" body={numberTemplate}/>
                        <Column field="valorMinimo" header="Valor Minimo" body={numberTemplate}/>
                        <Column field="valorMaximo" header="Valor Máximo" body={numberTemplate}/>
                        <Column field="resultado" header="Resultado" body={bodyResultado} />
                        <Column field="status" header="Status" body={bodyStatus} />
                        <Column field="tipoResultado" header="Tipo" body={(rowData) => execucaoPlanoQualidadeService.getTipoResultadoLabel(rowData.tipoResultado)} />
                    </DataTable>


                </div>
            </div>
        </>

    )
}